import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Đây là component App của riêng bạn
import reportWebVitals from './reportWebVitals';
import { App as AntdApp } from 'antd'; // <<< THÊM DÒNG NÀY ĐỂ IMPORT COMPONENT APP CỦA ANTD

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <<< BỌC COMPONENT APP CỦA BẠN TRONG <AntdApp> CỦA ANTD */}
    <AntdApp>
      <App />
    </AntdApp>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();